import {config, dom, library} from '@fortawesome/fontawesome-svg-core'
import {faAlarmClock, faCircle, faClockRotateLeft, faFilter, faLocationDot, faPlus, faShield} from "@fortawesome/free-solid-svg-icons";

config.mutateApproach = 'sync';

library.add(
	faFilter,
	faLocationDot,
	faAlarmClock,
	faClockRotateLeft,
	faShield,
	faPlus,
	faCircle
);

dom.watch();